/**
 * Đọc bản đồ bảy tầng do quiz gửi sang (localStorage) rồi đặt chiều dài bảy cột.
 *
 * Không có dữ liệu → để nguyên khối `hidden`. KHÔNG vẽ biểu đồ rỗng: khách vào thẳng trang
 * bán mà thấy một bản đồ trống là mất tin ngay, tệ hơn hẳn việc không có bản đồ nào.
 *
 * Dữ liệu là chữ NGƯỜI LẠ đưa vào (ai cũng sửa được localStorage của chính họ), nên nó CHỈ
 * được dùng làm SỐ để đặt chiều dài và làm KHOÁ TRA tên tầng. Không bao giờ ghi thẳng ra DOM.
 */
(function () {
  var KHOA = 'minespirit_ban_do';
  var HAN_NGAY = 30;

  var goc = document.querySelector('[data-pheu-ban-do]');
  if (!goc) return;

  var kho;
  try {
    kho = JSON.parse(localStorage.getItem(KHOA) || 'null');
  } catch (e) {
    return;
  }
  if (!kho || kho.v !== 1 || !kho.diem) return;

  /* Bản đồ cũ quá thì thôi — người ta làm quiz từ tháng trước, giờ tâm trạng khác rồi. */
  if (kho.luc && (Date.now() - kho.luc) > HAN_NGAY * 864e5) return;

  var hang = goc.querySelectorAll('[data-pbdo-hang]');
  if (!hang.length) return;

  var coSo = false;

  Array.prototype.forEach.call(hang, function (h) {
    var d = Number(kho.diem[h.getAttribute('data-pbdo-hang')]);
    if (!isFinite(d)) return;
    coSo = true;

    var ti = Math.max(0, Math.min(10, d)) * 10;
    var cot = h.querySelector('[data-pbdo-cot]');
    var so = h.querySelector('[data-pbdo-so]');
    /* Cột 0 điểm vẫn phải thấy được một vệt, kẻo trông như hàng bị lỗi chứ không phải điểm 0. */
    if (cot) cot.style.inlineSize = Math.max(ti, 1.5) + '%';
    if (so) so.textContent = (Math.round(d * 10) / 10).toString();

    if (kho.mong_nhat && h.getAttribute('data-pbdo-hang') === kho.mong_nhat) {
      h.setAttribute('data-pbdo-mong', '');
      var ct = goc.querySelector('[data-pbdo-chu-thich]');
      /* Chú thích đặt ngang hàng tầng mỏng nhất, không thả cuối biểu đồ. */
      if (ct) { h.insertAdjacentElement('afterend', ct); ct.removeAttribute('hidden'); }
    }
  });

  if (!coSo) return;
  goc.removeAttribute('hidden');

  /* Lá số sinh. Quiz gửi sang cung mọc + bảy hành tinh; không có thì khối này ẩn hẳn,
     cùng luật với biểu đồ: không vẽ rỗng, không bịa số. */
  try {
    var khungLS = document.querySelector('[data-pbdo-laso]');
    var oSao = document.querySelector('[data-pbdo-sao]');
    var ls = kho.sao;
    if (khungLS && oSao && ls && ls.sao && ls.sao.length) {
      var html = '';
      if (ls.asc && ls.asc.cung) {
        html += '<li class="pbdo__sao-i pbdo__sao-i--moc"><span class="pbdo__sao-ten">Rising</span>'
             +  '<span class="pbdo__sao-gt">' + ls.asc.do + ' ' + ls.asc.cung + '</span></li>';
      }
      for (var k = 0; k < ls.sao.length; k++) {
        var v = ls.sao[k];
        html += '<li class="pbdo__sao-i"><span class="pbdo__sao-ten">' + v.ten + '</span>'
             +  '<span class="pbdo__sao-gt">' + v.do + ' ' + v.cung + '</span></li>';
      }
      oSao.innerHTML = html;
      khungLS.removeAttribute('hidden');
    }
  } catch (e) { /* Thiếu dữ liệu lá số thì bỏ qua, biểu đồ bảy tầng vẫn chạy. */ }

})();
